var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarEventOn = function SvgNavbarEventOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M13.553 5.25H22.5V12h-9.75V5.25h-1.5V12H1.5V5.25h8.947l-2.69-2.69 1.06-1.06L12 4.682 15.182 1.5l1.06 1.06zM11.25 13.5h-7.5v6a3 3 0 0 0 3 3h4.5zm1.5 0v9h7.5v-9z",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarEventOn;